import TableFilter from './tableFilter'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import ExportButton from '../../common/ExportButton'
import { appAllGetHelpDesk } from '../../store/helpdesk'
import { helpDeskExportColumns } from '../../config/exportColumns/helpDeskExportColumns'

function HelpDesk() {
	const dispatch = useDispatch()
	const [exportFilters, setExportFilters] = useState({})
	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading d-flex justify-content-between">
					<div>Help Desk</div>

					<ExportButton
						fetchAction={params =>
							dispatch(
								appAllGetHelpDesk({
									...params,
									...exportFilters,
									hub: hubId || permissionOfHub,
									page: 1,
									limit: 100000,
									loading: false,
								}),
							)
						}
						columns={helpDeskExportColumns}
						fileName="Help_Desk"
						sheetName="Help Desk"
						buttonText="Export Help Desk"
					/>
				</div>

				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default HelpDesk
